<div class="task-widget" [class.task-widget--right-menu-active]="isRightMenuActive">
  <section class="task-panel" *ngIf="isOpen">
    <header class="task-panel__header">
      <div class="task-panel__title">Tasks</div>

      <div class="task-panel__header-actions">
        <button
          type="button"
          class="task-panel__icon-btn"
          (click)="clearFinished()"
          aria-label="Clear finished tasks">
          <mat-icon>delete_sweep</mat-icon>
        </button>

        <button
          type="button"
          class="task-panel__icon-btn"
          (click)="togglePanel()"
          aria-label="Close notifications panel">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </header>

    <div class="task-panel__list" *ngIf="(tasks$ | async) as tasks">
      <div class="task-panel__empty" *ngIf="tasks.length === 0">
        No tasks
      </div>

      <div
        class="task-row"
        *ngFor="let task of tasks; trackBy: trackByTaskId"
        [ngClass]="task.status">

        <div class="task-row__text">
          <div class="task-row__title">{{ task.title }}</div>

          <div class="task-row__message" *ngIf="task.message">
            {{ task.message }}
          </div>

          <div class="task-row__error" *ngIf="task.status === 'error' && task.error">
            {{ task.error }}
          </div>
        </div>

        <div class="task-row__action">
          <mat-spinner
            *ngIf="task.status === 'pending'"
            diameter="18"
            strokeWidth="3">
          </mat-spinner>

          <button
            *ngIf="task.status !== 'pending'"
            type="button"
            class="task-row__icon-btn"
            (click)="removeTask(task.id)"
            aria-label="Remove task">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </section>

  <button
    class="task-widget__toggle"
    (click)="togglePanel()"
    aria-label="Toggle notifications panel">
    <mat-icon>{{ isOpen ? 'close' : 'notifications' }}</mat-icon>
  </button>
</div>
